import { AccountAddEditForm } from "@/components/form/AccountAddEditForm"

export const TeamMemberCreateEdit = ({ actionType }: { actionType: "create" | "edit" }) => {
    return <AccountAddEditForm actionType={actionType} entityType="team-member"/>
}